const main_path = '@/pages/user'

const UserRoutes = [
  {
    path: '/users',
    name: 'Users',
    meta: { 
      auth: true, 
      tab_name: 'Usuários',
      roles: ['admin', 'super_admin'],
    },
    component: () => import(`@/pages/user/Users`)
  }
]

export default UserRoutes
